<template>
	<div class="animate_animated animate__slideInRight">
		<div class="fixed w-full top-0 left-0 z-20">
		  <div class=" bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
        <div class="h-1 bg-gradient-to-r from-amber-500 to-amber-200"></div>
				<div class="flex items-center px-4 py-4">
					<div class="flex items-center w-full">
						<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
						<span class="text-base text-content font-medium ml-4">New Enquiry</span>
					</div>
				</div>
			</div>
		</div>
		<div class="pt-20 bg-white mt-2">
			<div class="bg-white min-h-screen p-4">
        <Enquiry :enquiry="AddNewEnquiry"/>
			  <div class="mb-6 relative">
          <div v-if="DynamicForm == true">
            <div class="mb-6 relative">
              <div v-for="field in dynamicFields" :key="field.id" class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  {{ field.pretty_name }}
                  <span v-if="field.is_required" class="text-red-500">*</span>
                </label>
                <!-- SELECT -->
                <select
                  v-if="field.datatype === 'string' && field.is_select_list"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto custom-select focus:outline-none"
                >
                  <option value="">Select</option>
                  <option v-for="item in field.items" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
                <!-- TEXT -->
                <input
                  v-else-if="field.datatype === 'string'"
                  type="text"
                  v-model="magicFields[field.name]"
                  class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
                />
                <!-- NUMBER -->
                <input
                  v-else-if="field.datatype === 'integer'"
                  type="number"
                  v-model.number="magicFields[field.name]"
                  class="block w-full rounded-md border border-gray-300 p-2"
                />
                <!-- DATE -->
                <input
                  v-else-if="field.datatype === 'date'"
                  type="date"
                  v-model="magicFields[field.name]"
                  class="block w-full rounded-md border border-gray-300 p-2"
                />
                <!-- DATETIME -->
                <input
                  v-else-if="field.datatype === 'datetime'"
                  type="datetime-local"
                  v-model="magicFields[field.name]"
                  class="block w-full rounded-md border border-gray-300 p-2"
                />
                <!-- CHECKBOX -->
                <input
                  v-else-if="field.datatype === 'check_box_boolean'"
                  type="checkbox"
                  v-model="magicFields[field.name]"
                  class="h-4 w-4"
                />
                <!-- Fallback: simple text -->
                <input
                  v-else
                  type="text"
                  v-model="magicFields[field.name]"
                  class="block w-full rounded-md border border-gray-300 p-2"
                />
              </div>
            </div>
          </div>
			  </div>
        <div class="mt-10">
        <button type="button" @click="createEnquiry"
          class="bg-primary text-base font-semibold text-white rounded-full p-5 w-full disabled:opacity-50"
          >Submit</button>
      </div>
      </div>
		</div>
	</div>
</template>
<script>
import {prepareNextEnquiryParams} from '@/assets/scripts/utility.js';
import Enquiry from '@/components/Enquiry/Next.vue';
export default {
  name: 'next',
  components: {
    Enquiry
  },
  data () {
    return {
      dynamicFields: [],
      magicFields: {},
      DynamicForm: false,
      AddNewEnquiry: {
        require_furnishing: null,
        no_of_bathroom: null,
        no_of_parkings: null,
        floor_range: null,
        facing_direction: null,
        comment: null
      },
    }
  },
  created() {
    this.$axios.get(`mobile_crm/leads/magic_fields`)
      .then((res) => {
        const fields = res.data.magic_fields || []
        this.fetchDynamicFields(fields)
    })
    .catch((err) => console.log(err));
    },
  methods: {
    fetchDynamicFields(LeadsData) {
      this.dynamicFields = Array.isArray(LeadsData) ? LeadsData : []
      // Initialize magicFields defaults based on datatype
      this.dynamicFields.forEach((field) => {
        if (!(field.name in this.magicFields)) {
          if (field.datatype === 'check_box_boolean') {
            this.magicFields[field.name] = false
          } else {
            this.magicFields[field.name] = null
          }
        }
      })
      this.DynamicForm = true
    },
    createEnquiry() {
      let finalSubmitData = this.$store.getters.newEnquiryData
      let nextParams = prepareNextEnquiryParams(this.AddNewEnquiry)
      let leadData = {...finalSubmitData, ...nextParams,  ...this.magicFields}
      this.$axios
        .post("mobile_crm/leads", { lead: leadData })
        .then(res => {
          this.$swal.fire({
            title: "Enquiry Created!",
            icon: "success"
          }).then(this.$router.replace({ name: "Enquiry" }));
          this.$store.dispatch('setnewEnquiryData', null);
        })
        .catch(err => {
          if (err.response.status === 500) {
            this.$swal.fire({
              title: "Server Error!",
              icon: "error"
            });
          } else {
            this.$swal.fire({
              title: "Error",
              text: err.response.data.message,
              icon: "error"
            });
          }
        });
    },
  },
  computed: {
    leadKeysList(){
      return this.$store.getters.leadKeys;
    },
  }
}
</script>
<style scoped>

</style>